<template>
  <div class="modal fade" v-bind:id="id">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6 class="mb-4">{{ description }}</h6>
          <div>
            <button class="btn btn-outline-primary" v-on:click="cancel()">
              Cancel
            </button>
            <button
              class="btn float-right"
              v-bind:class="{
                'btn-primary': PositiveConfirmation,
                'btn-outline-danger': !PositiveConfirmation
              }"
              v-on:click="confirm()"
            >
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "ConfirmationModal",
  props: {
    Title: String,
    Description: String,
    ConfirmText: String,
    Id: String,
    PositiveConfirmation: Boolean
  },
  data() {
    return {
      title: this.Title,
      description: this.Description,
      confirmText: this.ConfirmText,
      id: this.Id
    };
  },
  methods: {
    confirm() {
      $("#" + this.id).modal("hide");
      this.$emit("confirm");
    },
    cancel() {
      $("#" + this.id).modal("hide");
      this.$emit("cancel");
    }
  }
};
</script>
